import { render } from "./Signin.vue?vue&type=template&id=1d54d194&scoped=true&bindings={\"shared\":\"options\",\"action\":\"setup\",\"user\":\"setup\",\"entrer\":\"setup\"}"
import script from "./Signin.vue?vue&type=script&lang=js"
export * from "./Signin.vue?vue&type=script&lang=js"

import "./Signin.vue?vue&type=style&index=0&id=1d54d194&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1d54d194"

export default script